import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import routerA from './router'
import store from './store'
import locale from 'element-ui/lib/locale/lang/mn'
import Amplify from 'aws-amplify'
import awsconfig from './aws-exports'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/reset.css'
import '@/assets/tailwind.css'
import VueApexCharts from 'vue-apexcharts'
import ReadMore from 'vue-read-more'
import * as VueGoogleMaps from 'vue2-google-maps'

let router = routerA.router
if (localStorage.getItem('type') === 'partner') {
  router = routerA.routerPartner
}
Vue.use(ElementUI, {
  locale
})
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Amplify.configure(awsconfig)
Vue.use(VueGoogleMaps, {
  installComponents: true,
  load: {
    key: 'AIzaSyAIns3enZwqky9L60Pfj1AmlfgIHyL6tUo',
    region: 'MN',
    language: 'mn',
    libraries: 'places'
  }
})
Vue.use(ReadMore, 'readMore')
export const bus = new Vue()

Vue.config.productionTip = false
new Vue({
  router,
  store,
  data: {
    username: '',
    email: ''
  },
  render: h => h(App)
}).$mount('#app')
